import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Clock, LogIn, LogOut } from "lucide-react";
import { toast } from "sonner";

export const TimeclockWidget = () => {
  const [s, setS] = useState(null);
  const load = () => api.get("/timeclock/me").then(({ data }) => setS(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const punch = async () => {
    const { data } = await api.post("/timeclock/punch");
    toast.success(data.on_shift ? "Entrada registrada" : "Saída registrada");
    load();
  };

  if (!s) return null;
  const last = s.entries[s.entries.length - 1];
  return (
    <div className="mx-3 mb-2 p-3 rounded-xl border border-border bg-muted/40" data-testid="timeclock-widget">
      <div className="flex items-center gap-2 text-xs font-semibold">
        <Clock className="w-3.5 h-3.5" /> Ponto
        <span className={`ml-auto status-dot ${s.on_shift ? "bg-emerald-500" : "bg-slate-400"}`} />
        <span data-testid="timeclock-status">{s.on_shift ? "Em jornada" : "Fora da jornada"}</span>
      </div>
      {last && <div className="text-[10px] text-muted-foreground mt-1">Último: {last.type === "in" ? "entrada" : "saída"} às {new Date(last.at).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}</div>}
      {s.required && !s.on_shift && !s.exempt && <div className="text-[10px] text-amber-600 mt-1">Registre a entrada para responder clientes</div>}
      <Button size="sm" onClick={punch} data-testid="timeclock-punch-button"
              className={`w-full mt-2 h-8 ${s.on_shift ? "" : "bg-emerald-600 hover:bg-emerald-700"}`} variant={s.on_shift ? "outline" : "default"}>
        {s.on_shift ? <><LogOut className="w-3.5 h-3.5 mr-1" /> Registrar saída</> : <><LogIn className="w-3.5 h-3.5 mr-1" /> Registrar entrada</>}
      </Button>
    </div>
  );
};
